import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RewriteUrlComponent from '../components/RewriteUrlComponent';
import PrivateRoutes from '../services/privateRouter';
import Profile from '../pages/profile/profile';
import PostOfUser from '../pages/postOfUser/index';
import ProductOfUser from '../pages/productOfUser/index';
import ManageProduct from '../pages/ManageProduct';
import AddEditProduct from '../pages/AddEditProduct';
import Favorites from '../containers/favorites';
import UserProfile from '../containers/user_profile';
import ManagerComment from '../pages/managerWarnings/index';
import UpdatePassword from '../pages/updatePassword/updatePassword';
import WeatherSetting from '../pages/weatherSetting/weatherSetting';
import InvoicesIndex from '../pages/InvoicesMarket';
import ShippingUnitIndex from '../pages/ShippingUnit/ShippingUnitIndex';
import DetailInvoiceNotAuthen from '../pages/InvoiceDetail/DetailInvoiceNotAuthen';
import DetailRefundInvoice from '../pages/InvoiceDetail/DetailRefundInvoice';
import CreateShipping from '../pages/createShipping/createShipping';
import ReportRevenueIndex from '../pages/reportRevenue/reportRevenueIndex';
import ListInvoiceRevenue from '../pages/InvoicesMarket/ListInvoiceRevenue';
import ManageContribute from '../pages/manageContribute';
import Cart from 'pages/Cart/cart';
import NewSettingWeather from 'pages/weatherSetting/new';
import EditWeatherSchedule from 'pages/weatherSetting/edit';
import UserAlbums from '../pages/UserAlbums';
import Detail from '../pages/InvoiceDetail/Detail';

function UsersRoutes() {
  return (
      <Routes>
      <Route element={<PrivateRoutes />}>
      <Route path="/nguoi-dung">
        <Route path="/nguoi-dung/trang-ca-nhan" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/bai-viet" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/san-pham" element={<RewriteUrlComponent />}>
          <Route index element={<RewriteUrlComponent />} />
          <Route path="new" element={<RewriteUrlComponent />} />
          <Route path="edit/:productId" element={<RewriteUrlComponent />} />
        </Route>

        <Route path="/nguoi-dung/san-pham-yeu-thich" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/:userId" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/quan-ly-binh-luan" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/cap-nhat-mat-khau" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/thiet-lap-thong-bao" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/don-hang-cua-toi" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/thiet-lap-don-vi-van-chuyen" element={<RewriteUrlComponent />} />

        <Route
          path="/nguoi-dung/thong-tin-don-hang-ban/:invoiceId"
          element={<RewriteUrlComponent type="seller" />}
        />

        <Route
          path="/nguoi-dung/thong-tin-don-hang-mua/:invoiceId"
          element={<RewriteUrlComponent type="buyer" />}
        />

        <Route
          path="/nguoi-dung/thong-tin-don-ban-hoan-tra/:invoiceId"
          element={<RewriteUrlComponent type="sales" />}
        />
        <Route
          path="/nguoi-dung/thong-tin-don-mua-hoan-tra/:invoiceId"
          element={<RewriteUrlComponent type="purchase" />}
        />
        <Route path="/nguoi-dung/thong-tin-don-hang-ban/:invoiceId/van-don" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/bao-cao-tong-quan" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/danh-sach-don-hang-doanh-thu" element={<RewriteUrlComponent />} />

        <Route path="/nguoi-dung/quan-ly-dong-gop" element={<RewriteUrlComponent />} />
      </Route>

      <Route path="/thanh-vien">
        <Route path="/thanh-vien/trang-ca-nhan" element={<Profile />} />

        <Route path="/thanh-vien/bai-viet" element={<PostOfUser />} />

        <Route path="/thanh-vien/san-pham" element={<ProductOfUser />}>
          <Route index element={<ManageProduct />} />
          <Route path="new" element={<AddEditProduct />} />
          <Route path="edit/:productId" element={<AddEditProduct />} />
        </Route>

        <Route path="/thanh-vien/san-pham-yeu-thich" element={<Favorites />} />

        <Route path="/thanh-vien/:userId" element={<UserProfile />} />

        <Route path="/thanh-vien/quan-ly-binh-luan" element={<ManagerComment />} />

        <Route path="/thanh-vien/cap-nhat-mat-khau" element={<UpdatePassword />} />

        <Route path="/thanh-vien/thiet-lap-thong-bao" element={<WeatherSetting />} />

        <Route path="/thanh-vien/don-hang-cua-toi" element={<InvoicesIndex />} />

        <Route path="/thanh-vien/thiet-lap-don-vi-van-chuyen" element={<ShippingUnitIndex />} />

        <Route path="/thanh-vien/thong-tin-don-hang-ban/:invoiceId" element={<DetailInvoiceNotAuthen type="seller" />} />

        <Route path="/thanh-vien/thong-tin-don-hang-mua/:invoiceId" element={<Detail type="buyer" />} />

        <Route
          path="/thanh-vien/thong-tin-don-ban-hoan-tra/:invoiceId"
          element={<DetailRefundInvoice type="sales" />}
        />

        <Route
          path="/thanh-vien/thong-tin-don-mua-hoan-tra/:invoiceId"
          element={<DetailRefundInvoice type="purchase" />}
        />

        <Route path="/thanh-vien/thong-tin-don-hang-ban/:invoiceId/van-don" element={<CreateShipping />} />

        <Route path="/thanh-vien/bao-cao-tong-quan" element={<ReportRevenueIndex />} />

        <Route path="/thanh-vien/danh-sach-don-hang-doanh-thu" element={<ListInvoiceRevenue />} />

        <Route path="/thanh-vien/quan-ly-dong-gop" element={<ManageContribute />} />
      </Route>
      <Route path="/gio-hang" element={<Cart />} />
    </Route>
    <Route path="/nguoi-dung/thiet-lap-thong-bao/tao-moi" element={<RewriteUrlComponent isEditMode={false} />} />
    <Route path="/thanh-vien/thiet-lap-thong-bao/tao-moi" element={<NewSettingWeather isEditMode={false} />} />

    <Route
      path="/nguoi-dung/thiet-lap-thong-bao/chinh-sua/:weatherId"
      element={<RewriteUrlComponent isEditMode={true} />}
    />
    <Route
      path="/thanh-vien/thiet-lap-thong-bao/chinh-sua/:weatherId"
      element={<EditWeatherSchedule isEditMode={true} />}
    />

    <Route path="/nguoi-dung/albums/:albumId" element={<RewriteUrlComponent />} />
    <Route path="/thanh-vien/albums/:albumId" element={<UserAlbums />} />

      </Routes>
  );
}

export default UsersRoutes;
